<template>
    <b-modal id="modal-multi-add"
            size="lg"
            ref="sub-merchant-modal"
            :title="'新增附屬帳戶'"
            centered
            :hide-header="success"
            :content-class="success ? 'success-modal-content' : 'add-modal-content'"
            :dialog-class="success ? 'success-modal-dialog' : 'add-modal-dialog'"
            :body-class="success ? 'success-modal-body' : 'add-modal-body'"
            :header-class="success ? 'success-modal-header' : 'add-modal-header'"
            :title-class="success ? 'success-modal-title' : 'add-modal-title'"
            hide-footer
            @hide="initialize()">
      <ValidationObserver ref="form">
        <form @submit.prevent
              v-stream:submit="onSubmit$"
              >
          <transition name="slide-left" mode="out-in">
            <div v-if="success"
                key="'success'"
                class="success-modal">
              <CustomLottie
                :animationData="animationData"
                style="margin-bottom: 24px;"
              ></CustomLottie>
              <span class="title">你已成功新增附屬帳號</span>
              <footer>
                <b-button size="md"
                          variant="primary"
                          @click="hideModal"
                >
                  完成
                </b-button>
              </footer>
            </div>
            <div v-else
                :key="'form'"
                class="reset-password__frag"
            >
            <h6>分店/店鋪名稱</h6>
              <AGCInput v-model="subMerchantName"
                        type="text"
                        name="分店/店鋪名稱（識別用）"
                        placeholder="輸入分店/店鋪名稱（識別用）"
                        rules="required"
                        required
              ></AGCInput>
              <h6 style="margin-bottom: 0px;">附屬帳戶登入名稱</h6>
              <span class="tips">
                附屬帳戶登入名稱支援小寫英文字母、數字、半形符號「-」及「_」，最多15個字。
              </span>
              <AGCInput v-model="username"
                        type="text"
                        name="附屬帳戶登入名稱"
                        placeholder="輸入附屬帳戶登入名稱"
                        rules="required|username|max:15"
                        required
              ></AGCInput>
              <h6 class="password">密碼</h6>
              <span class="tips">
                密碼最少8個字，必須包含數字及大，小寫英文字母（不支援特殊符號）。
              </span>
              <AGCInput v-model="password"
                        type="password"
                        vid="password"
                        name="輸入新密碼"
                        placeholder="輸入新密碼"
                        rules="required|password"
                        required
              >
              <AGCInput v-model="confirmPassword"
                          type="password"
                          name="新密碼"
                          placeholder="新密碼"
                          rules="required|confirmed:password"
                          required
              ></AGCInput>
                <template v-slot:invalidFeedback="{ errors }">
                  <span
                    style="font-size: 80%;color:#dc3545;"
                    :style="{ display: errors[0] ? 'block' : 'none' }"
                  >
                    密碼最少8個字，必須包含數字及大，小寫英文字母（不支援特殊符號）。
                  </span>
                </template>
              </AGCInput>
              <AGCInput v-model="confirmPassword"
                        type="password"
                        name="再次輸入新密碼"
                        placeholder="再次輸入新密碼"
                        rules="required|confirmed:password"
                        required
              ></AGCInput>
              <div class="row justify-content-end px-3">
                <b-button size="md"
                          class="mr-2"
                          variant="light"
                          @click="hideModal"
                          >
                  取消
                </b-button>
                <b-button size="md"
                          type="submit"
                          variant="btn btn-primary"
                          :disabled="loading"
                >
                  提交
                </b-button>
              </div>
          </div>
        </transition>
      </form>
      </ValidationObserver>
    </b-modal>
</template>

<script>
import { mapGetters } from 'vuex';
import CustomLottie from '@/components/CustomLottie.vue';
import {
  switchMap, tap,
} from 'rxjs/operators';
import {
  BButton,
  BModal,
} from 'bootstrap-vue';
import animationData from '@/assets/lottie/change-password-success.json';
import AGCInput from '@/components/form/AGCInput.vue';
import formMixin from '../../mixins/form';
import agcFormElementMixin from '../../mixins/agc-form-element';
import http from '../../helpers/http';
import toastSettings from '../../helpers/toast-settings';
import { getErrorMsg } from '../../helpers/error-msg';

export default {
  mixins: [agcFormElementMixin, formMixin],
  props: ['merchantId', 'list'],
  data: () => ({
    subMerchantName: null,
    username: null,
    password: null,
    confirmPassword: null,
    loading: false,
    success: false,
    animationData,
  }),
  computed: {
    ...mapGetters(['role']),
  },
  components: {
    BModal,
    AGCInput,
    CustomLottie,
    BButton,
  },
  methods: {
    hideModal() {
      this.$refs['sub-merchant-modal'].hide();
      this.success = false;
    },
    initialize() {
      this.subMerchantName = '';
      this.username = null;
      this.password = null;
      this.confirmPassword = null;
    },
  },
  domStreams: ['onSubmit$'],
  subscriptions() {
    return {
      submit: this.onSubmit$
        .pipe(
          switchMap(this.validate),
          tap(() => {
            this.loading = true;
          }),
          switchMap(() => http({
            method: 'POST',
            url: `/agc-${this.role}-api/submerchants/create`,
            data: {
              merchantId: this.merchantId,
              name: this.subMerchantName,
              username: this.username,
              password: this.password,
            },
          }, {
            next: (res) => {
              this.success = true;
              this.$emit('update', res.result[0]);
              this.initialize();
            },
            error: ({ data: { msg } }) => {
              this.$bvToast.toast(getErrorMsg(msg, { DUPLICATED: '名稱已重覆，請重新輸入' }), {
                ...toastSettings,
                title: '錯誤',
                toaster: 'b-toaster-top-center',
              });
            },
            complete: () => {
              this.loading = false;
            },
          })),
        ),
    };
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/transition/slide";

::v-deep {
  .add-modal {
    &-content {
      border: none;
    }

    &-dialog {
      max-width: 530px;
    }

    &-title {
      font-size: 18px;
      font-weight: 400;
      width: 100%;
      text-align: center;
    }

    &-header {
      padding: 24px;
      border-bottom: none;
    }

    &-header .close {
      font-size: 19px;
      padding-top: 20px;
    }

    &-body {
      padding: 0 24px 24px 24px !important;

      .form-control {
        padding: 12px 14px !important;
        font-size: 15px !important;
        height: 100%;
        border: 1px solid #ced4d9;
      }
      .px-3 {
        padding-top: 8px;
      }
      .btn {
        padding: 9px 18px;
        min-width: 111px;

        &-light {
          margin-right: 12px !important;
          background-color: #f9f9fa;
          border: 1px solid #dde1e5;
          color: #636d77;
        }
      }
      h6.password {
        display: inline-block;
      }

      span.tips {
        font-size: 0.7em;
        color: #757575;
      }
    }
  }

  .success-modal {
    display: inline-block;
    text-align: center;
    width: 100%;
    .title {
      display: block;
      font-size: 18px;
    }
    &-dialog {
      min-width: 380px;
    }

    &-content {
      border: none;
    }

    &-body {
      padding: 32px;
    }

    .btn {
      margin: 0 auto;
      min-width: 111px;
      padding: 9px 18px;
    }

    footer {
      border: none;
      padding: 28px 0 0 0;
    }
  }

  @font-face {
    font-family: 'Noto Sans TC';
    font-style: normal;
    font-weight: 300;
    src: url(//fonts.gstatic.com/ea/notosanstc/v1/NotoSansTC-Light.woff2) format('woff2'),
      url(//fonts.gstatic.com/ea/notosanstc/v1/NotoSansTC-Light.woff) format('woff'),
      url(//fonts.gstatic.com/ea/notosanstc/v1/NotoSansTC-Light.otf) format('opentype');
  }
  .form-control {
    &::-moz-placeholder {
      color: #7e8b93;
      opacity: 1;
      font-weight: 300;
    }
    &:-ms-input-placeholder {
      color: #7e8b93;
      opacity: 1;
      font-weight: 300;
    }
    &::placeholder {
      color: #7e8b93;
      opacity: 1;
      font-weight: 300;
    }
  }
}
</style>
